import { AlphaAuditClient } from '../alphaAuditClient';
import {
  AuditContext,
  AuditDecision,
  AuditExecutionResult,
} from '../alphaAuditTypes';

export async function defaultAuditHandler(
  client: AlphaAuditClient,
  decision: Extract<AuditDecision, { auditable: true }>,
  _ctx: AuditContext
): Promise<AuditExecutionResult> {
  const { auditId, downloadUrl } = await client.startAudit(
    decision.auditFunctionName,
    decision.payload
  );

  return {
    kind: 'download',
    auditId,
    downloadUrl,
    filename: `excel_alpha_audit_${auditId}.xlsx`,
  };
}